module.exports = __webpack_public_path__ + "img/randomizer-details2.f60b0a77.png";